import {
  Box,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid2,
  InputLabel,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import { useSelectedCandidatesMutation } from "../../redux/candidateprofiles/candidateprofiles.api";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import { TableLoader } from "../../reusable_components/components/TableLoader";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import MuiDatePicker from "../../reusable_components/components/MuiDatePicker";
import { CalendarIcon } from "lucide-react";
import MUIButton from "../../reusable_components/components/MUIButton";

const SelectedCandidate = ({ search }) => {
  const { Snackbar } = useContext(SnackbarContext);
  const [showTableLoader, setShowTableLoader] = useState(false);
  const [isPrevious, setIsPrevious] = useState(true)
  const [triggerApi, setTriggerApi] = useState(false);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showClearFilter, setShowClearFilter] = useState(false);
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const [page, setPage] = useState(
    +localStorage.getItem("selectedCandidateSearch") || 1
  );
  const navigate = useNavigate();
  const commonFilter = JSON.parse(localStorage.getItem("commonsearchfilter"));

  const [selectedData] = useSelectedCandidatesMutation();

  const [selectedDatas, setSelectedDatas] = useState([]);
  const [counts, setCounts] = useState(0);
  const { Profile } = useSelector((state) => state.common);
  const userRole = Profile?.profile?.role;
  const isExternal = Profile?.profile?.isExternalRecruiter;

  const [fromDate, setFromDate] = useState(
    commonFilter?.candidateProfiles?.fromDate
      ? dayjs(commonFilter?.candidateProfiles?.fromDate)
      : null
  );
  const [toDate, setToDate] = useState(
    commonFilter?.candidateProfiles?.toDate
      ? dayjs(commonFilter?.candidateProfiles?.toDate)
      : null
  );
  const [sourcedBy, setSourcedBy] = useState(
    commonFilter?.candidateProfiles?.sourcedBy || ""
  );

  const selectedTableDatas = async () => {
    try {
      const payload = {
        page: page ? page - 1 : 0,
        size: rowsPerPage ? rowsPerPage : 10,
        candidateSearch: search,
        fromDate: fromDate ? dayjs(fromDate).format("YYYY-MM-DD") : null,
        toDate: toDate ? dayjs(toDate).format("YYYY-MM-DD") : null,
        sourceBy: sourcedBy || "",
      };
      setShowTableLoader(true);
      const response = await selectedData(payload).unwrap();
      setShowTableLoader(false);
      setSelectedDatas(response?.response?.data);
      setCounts(response?.response?.totalItems);
      setIsPrevious(false)
    } catch (error) {
      Snackbar("Network failed", "error");
      setShowTableLoader(false);
    }
  };

  useEffect(() => {
    if (search && !isPrevious) {
      if (page > 1) {
        setPage(1);
        localStorage.setItem("selectedCandidateSearch", 1);
      }
    }
    selectedTableDatas();
  }, [search]);

  useEffect(() => {
    selectedTableDatas();
    setTriggerApi(false);
  }, [rowsPerPage, page, triggerApi]);

  useEffect(() => {
    if (shouldFetch) {
      letsFilterDatas()
      setShouldFetch(false);
      setTriggerApi(true);
      setFilterDialogOpen(false);
    }
  }, [shouldFetch]);


  const handleChangePage = (e, newPage) => {
    localStorage.setItem("selectedCandidateSearch", newPage);
    setPage(newPage);
  };

  const handleCandidateNav = (item) => {
    navigate(`/candidate-view/${item?.profileId}`, {
      state: { offer: true },
    });
    setIsPrevious(true)
  };

  const handleOpenFillterDialog = () => {
    setFilterDialogOpen(true);
  };

  const hanldeFromDate = (value) => {
    if (toDate && toDate <= value) {
      setToDate(null);
    }
    setFromDate(value);

    const currentFilter =
      JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

    const updatedFilter = {
      ...currentFilter,
      candidateProfiles: {
        ...currentFilter.candidateProfiles,
        fromDate: value,
      },
    };

    localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
  };

  const handleTodate = (value) => {
    setToDate(value);

    const currentFilter =
      JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

    const updatedFilter = {
      ...currentFilter,
      candidateProfiles: {
        ...currentFilter.candidateProfiles,
        toDate: value,
      },
    };

    localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
  };

  const getNextDay = (fromDate) => {
    if (!fromDate) {
      return null;
    }
    return dayjs(fromDate)?.add(1, "day");
  };

  const handleSourcedBy = (e) => {
    setSourcedBy(e.target.value);
    const value = e.target.value;

    const currentFilter =
      JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

    const updatedFilter = {
      ...currentFilter,
      candidateProfiles: {
        ...currentFilter.candidateProfiles,
        sourcedBy: value,
      },
    };

    localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
  };
  const [chips, setChips] = useState([]);

  const letsFilterDatas = () => {
    const updateChip = [
      fromDate && {
        label: fromDate ? dayjs(fromDate)?.format("DD-MM-YYYY") : "",
        onDelete: () => {
          setFromDate(null);
          localStorage.setItem(
            "commonsearchfilter",
            JSON.stringify({
              ...commonFilter,
              candidateProfiles: {
                ...commonFilter.candidateProfiles,
                fromDate: null,
              },
            })
          );
          setTriggerApi(true);
          setToDate(null);
          setChips((prevChips) =>
            prevChips?.filter(
              (chips) => chips?.label !== dayjs(fromDate)?.format("DD-MM-YYYY")
            )
          );
        },
      },
      toDate && {
        label: toDate ? dayjs(toDate)?.format("DD-MM-YYYY") : "",
        onDelete: () => {
          setToDate(null);
          localStorage.setItem(
            "commonsearchfilter",
            JSON.stringify({
              ...commonFilter,
              candidateProfiles: {
                ...commonFilter.candidateProfiles,
                toDate: null,
              },
            })
          );
          setTriggerApi(true);
          setChips((prevChips) =>
            prevChips?.filter(
              (chips) => chips?.label !== dayjs(toDate)?.format("DD-MM-YYYY")
            )
          );
        },
      },
      {
        label: sourcedBy,
        onDelete: () => {
          setSourcedBy("");
          localStorage.setItem(
            "commonsearchfilter",
            JSON.stringify({
              ...commonFilter,
              candidateProfiles: {
                ...commonFilter.candidateProfiles,
                sourcedBy: "",
              },
            })
          );
          setTriggerApi(true);
          setChips((prevChips) =>
            prevChips?.filter((chips) => chips?.label !== sourcedBy)
          );
        },
      },
    ].filter(Boolean);

    setChips(updateChip);
    setTriggerApi(true);
    setShowClearFilter(true);
  };

  const formatDate = (date = new Date()) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handleCloseFilterDialog = () => {
    setFilterDialogOpen(false);
    const hasValue = chips?.some((item) => item?.label);

    if (!hasValue) {
      setSourcedBy("");
      setFromDate(null);
      setToDate(null);
      localStorage.setItem(
        "commonsearchfilter",
        JSON.stringify({ ...commonFilter, candidateProfiles: {} })
      );
    }
  };

  const handleclearFilterState = () => {
    setFromDate(null);
    setToDate(null);
    setSourcedBy("");
    setTriggerApi(true);
    setShowClearFilter(false);
    localStorage.setItem(
      "commonsearchfilter",
      JSON.stringify({ ...commonFilter, candidateProfiles: {} })
    );
  };


  useEffect(() => {
    const candidateProfiles = commonFilter?.candidateProfiles;
    const hasValue =
      candidateProfiles &&
      Object.values(candidateProfiles)?.some(
        (value) =>
          value !== 0 && value !== null && value !== undefined && value !== ""
      );

    if (hasValue) {
      setShouldFetch(true);
    }
  }, []);

  return (
    <Box>
      <Paper
        sx={{
          width: "100%",
          overflow: "auto",
          marginTop: "10px",
          border: "1px solid #E9EAEB",
          borderRadius: "10px",
        }}
        elevation={0}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell colSpan={100} sx={{ padding: "5px" }}>
                <Box
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    {showClearFilter &&
                      chips?.map(
                        (chip, index) =>
                          chip?.label && (
                            <Chip
                              variant="outlined"
                              size="small"
                              className="Chip"
                              key={index}
                              label={chip?.label}
                              deleteIcon={
                                <CloseIcon
                                  sx={{ color: "#414651 !important" }}
                                />
                              }
                              onDelete={chip?.onDelete}
                            />
                          )
                      )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "14px",
                    }}
                  >
                    <MUICancelButton
                      title="More Filters"
                      onClick={handleOpenFillterDialog}
                      startIcon={
                        <FilterListOutlinedIcon
                          sx={{ fontSize: "14px !important" }}
                        />
                      }
                      sx={{
                        color: "#6941C6",
                        borderColor: "#D6BBFB",
                        fontWeight: 600,
                        width: "130px",
                      }}
                    />
                    {(fromDate ||
                      toDate ||
                      sourcedBy) &&
                      showClearFilter && (
                        <MUICancelButton
                          title="Clear filter"
                          onClick={handleclearFilterState}
                          sx={{ width: "100px" }}
                        />
                      )}
                  </div>
                </Box>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="tableHeadersCell_2">Name</TableCell>
              <TableCell className="tableHeadersCell_2">Email</TableCell>
              <TableCell className="tableHeadersCell_2">
                Position Name
              </TableCell>
              <TableCell className="tableHeadersCell_2">Client Name</TableCell>
              <TableCell className="tableHeadersCell_2">Sourced By</TableCell>
              <TableCell className="tableHeadersCell_2">
                Selected Date
              </TableCell>
            </TableRow>
          </TableHead>
          {!showTableLoader ? (
            selectedDatas.length > 0 ? (
              <TableBody>
                {selectedDatas.map((item, index) => (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={item.code}
                    sx={{
                      backgroundColor: index % 2 === 1 ? "#FAFAFA" : "inherit",
                      "&:hover": { backgroundColor: "#f1f1f1" },
                    }}
                  >
                    <TableCell
                      className="tableBodyCells"
                      onClick={() => handleCandidateNav(item)}
                      sx={{ cursor: "pointer" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        <Typography className="tableBodyCells">
                          <span
                            style={{
                              color: "#53389E",
                              fontWeight: 600,
                              fontSize: "12px",
                            }}
                          >
                            {item?.profileName}
                          </span>
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell className="tableBodyCells">
                      {item?.emailId}
                    </TableCell>
                    <TableCell className="tableBodyCells">
                      {item?.positionName}
                    </TableCell>
                    <TableCell className="tableBodyCells">
                      {item?.clientName}
                    </TableCell>
                    <TableCell className="tableBodyCells">
                      <span
                        style={{
                          color: "#53389E",
                          fontWeight: 600,
                          fontSize: "12px",
                        }}
                      >
                        {item?.sourceBy}
                      </span>
                    </TableCell>
                    <TableCell className="tableBodyCells">
                      {item?.eventDate == "NA"
                        ? "NA"
                        : dayjs(item?.eventDate).format("DD-MM-YYYY")}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            ) : (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={5}>
                    <Typography className="emptydatas">
                      No Data Found
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            )
          ) : (
            <TableRow>
              <TableCell colSpan={5}>
                <Box className="tableloader">
                  <TableLoader />
                </Box>
              </TableCell>
            </TableRow>
          )}
          <TableRow>
            {counts <= rowsPerPage ? null : (
              <TableCell colSpan={100}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <MUICancelButton
                    title="Previous"
                    startIcon={
                      <ArrowBackIcon
                        sx={{ color: page === 1 ? "#a2a2a2" : "#414651" }}
                      />
                    }
                    disabled={page === 1}
                    onClick={() => handleChangePage(null, page - 1)}
                    sx={{ height: "36px" }}
                  />
                  <Pagination
                    page={page}
                    onChange={handleChangePage}
                    count={Math.ceil(counts / rowsPerPage)}
                    siblingCount={3}
                    boundaryCount={3}
                    shape="rounded"
                    hidePrevButton
                    hideNextButton
                  />

                  <MUICancelButton
                    title="Next"
                    startIcon={
                      <ArrowForwardIcon
                        sx={{
                          color:
                            page === Math.ceil(counts / rowsPerPage)
                              ? "#a2a2a2"
                              : "#414651",
                        }}
                      />
                    }
                    disabled={page === Math.ceil(counts / rowsPerPage)}
                    onClick={() => handleChangePage(null, page - 1)}
                    sx={{ height: "36px" }}
                  />
                </div>
              </TableCell>
            )}
          </TableRow>
        </Table>
      </Paper>

      <Grid2 item>
        <Dialog
          open={filterDialogOpen}
          scroll="paper"
          maxWidth="md"
          className="sidePopup"
        >
          <DialogTitle
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography sx={{ fontWeight: 600, fontSize: "18px" }}>
              Filters
            </Typography>
            <CloseIcon
              onClick={() => setFilterDialogOpen(false)}
              sx={{ cursor: "pointer" }}
            />
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Grid2
                container
                rowGap={2}
                sx={{ display: "flex", width: "100%" }}
              >

                <Box sx={{ width: "100%" }}>
                  <InputLabel className="input">From Date</InputLabel>
                  <MuiDatePicker
                    value={fromDate}
                    onChange={hanldeFromDate}
                    slots={{
                      openPickerIcon: CalendarIcon,
                    }}
                    slotProps={{
                      textField: {
                        size: "small",
                        placeholder: "Choose By From Date",
                        InputProps: {
                          sx: { borderRadius: "10px", height: "35px" },
                        },
                      },
                    }}
                    sx={{
                      "& .MuiInputBase-input": {
                        fontSize: "14px",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: "20px",
                      },
                    }}
                    format="DD-MM-YYYY"
                  />
                </Box>
                <Box sx={{ width: "100%" }}>
                  <InputLabel className="input">To Date</InputLabel>
                  <MuiDatePicker
                    value={toDate}
                    onChange={handleTodate}
                    slots={{
                      openPickerIcon: CalendarIcon,
                    }}
                    slotProps={{
                      textField: {
                        size: "small",
                        placeholder: "Choose By To Date",
                        InputProps: {
                          sx: { borderRadius: "10px", height: "35px" },
                        },
                      },
                    }}
                    sx={{
                      "& .MuiInputBase-input": {
                        fontSize: "14px",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: "20px",
                      },
                    }}
                    format="DD-MM-YYYY"
                    minDate={getNextDay(fromDate) || null}
                    maxDtae={dayjs()}
                    disabled={!fromDate}
                  />
                </Box>

                <Box sx={{ width: "100%" }}>
                  <InputLabel className="input"> Sourced By </InputLabel>
                  <TextField
                    className="textfields"
                    size="small"
                    placeholder=" Search Sourced By"
                    value={sourcedBy || ""}
                    onChange={handleSourcedBy}
                  />
                </Box>
              </Grid2>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Grid2
              item
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                gap: "20px",
              }}
            >
              <MUICancelButton
                title="Cancel"
                sx={{ width: "42%" }}
                onClick={handleCloseFilterDialog}
              />
              <MUIButton
                title="Apply"
                sx={{ width: "42%" }}
                onClick={() => {
                  setPage(1);
                  setShouldFetch(true);
                }}
              />
            </Grid2>
          </DialogActions>
        </Dialog>
      </Grid2>

    </Box>
  );
};

export default SelectedCandidate;
